import { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Element } from '../../common/html/element'
import { STATUS_MESS } from '../constants'
import { changeTyping, changStatusMess } from '../store/slice'

const TypingBubble = memo(
  ({ text, speed = 20, scrollRef, isAutoScroll, formatText }) => {
    const dispatch = useDispatch()
    const [displayedText, setDisplayedText] = useState('')
    const [index, setIndex] = useState(0)

    useEffect(() => {
      let timeout
      if (document.visibilityState === 'hidden') {
        setDisplayedText(text)
        setIndex(text.length)
        dispatch(changeTyping({ done: true }))
        dispatch(changStatusMess(STATUS_MESS.SUCCESS))
        return
      }

      if (index < text.length) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev + text.charAt(index))
          setIndex((prev) => prev + 1)
          if (index + 1 === text.length) {
            dispatch(changeTyping({ done: true }))
            dispatch(changStatusMess(STATUS_MESS.SUCCESS))
          }
        }, speed)
      }

      return () => clearTimeout(timeout)
    }, [index, text, speed, dispatch])

    useEffect(() => {
      if (scrollRef?.current && isAutoScroll) {
        scrollRef.current.scrollToBottom()
      }
    }, [displayedText, scrollRef, isAutoScroll])

    return (
      <Element
        className="content-ai-chat"
        style={{ fontSize: 14 }}
        dangerouslySetInnerHTML={{ __html: formatText(displayedText) }}
      />
    )
  },
)

export default TypingBubble
